import { styled } from '@styledComponents';
import { themeColor, themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { JoykitColor } from '@components/themes';

export const FlipCard = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  ${themeMediaQuery('sm')} {
    justify-content: flex-end;
  }
`;

const cardRatio = 530 / 750;

export const FlipCardWrapper = styled.div`
  width: calc(60vh * ${cardRatio});
  height: 60vh;
  perspective: 800px;
  margin: auto;
  ${themeMediaQuery('sm')} {
    width: calc(35vh * ${cardRatio});
    height: 35vh;
  }
  ${themeMediaQuery('md')} {
    width: calc(60vh * ${cardRatio});
    height: 60vh;
  }
`;

export const TemplateShadow = styled.div<{ backgroundColor: JoykitColor; shadowColor: JoykitColor }>`
  position: absolute;
  right: 20px;
  height: 100%;
  background-color: ${({ backgroundColor }) => themeColor(backgroundColor)};
  box-shadow: 0px 32px 64px ${({ shadowColor }) => themeColor(shadowColor)};
  border-radius: 70px;
`;

export const MainTextPairing = styled(TextPairing)<{ isImageRight?: boolean }>`
  max-width: 268px;
  .text-pairing-title {
    max-width: 320px;
  }
  ${themeMediaQuery('sm')} {
    max-width: 427px;
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 360px;
    }
  }
`;

export const ImageColumn = styled(Columns.Column)<{ isImageLeft?: boolean }>`
  ${themeMediaQuery('sm')} {
    order: ${({ isImageLeft }) => (isImageLeft ? -1 : 1)};
  }
`;

export const TextColumn = styled(Columns.Column)`
  display: flex;
  align-items: center;
`;

/*
  Note: The $ here makes $isBackFace and $isTextCard transient props, meaning that they are only used in this component
  and not forwarded to CloudImage, which is necessary here since CloudImage does not have these props, nor are they a
  concern to CloudImage.

  See this StackOverflow for more information:
  https://stackoverflow.com/questions/58721822/avoid-passing-down-props-using-styled-components-and-typescript
 */
export const ImageCard = styled(CloudImage)<{ $isBackFace?: boolean; $isTextCard?: boolean }>`
  position: absolute;
  height: 100%;
  width: 100%;
  backface-visibility: hidden;
  transform: ${({ $isBackFace }) => ($isBackFace ? 'rotateY(180deg)' : 'none')};
  background-color: ${({ $isTextCard, $isBackFace }) => (!$isTextCard && $isBackFace ? 'white' : 'none')};
`;

export const ColumnsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  direction: rtl;
  ${themeMediaQuery('below_sm')} {
    direction: ltr;
  }
`;

export const MainTextWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  direction: ltr;
  ${themeMediaQuery('below_sm')} {
    position: relative;
    margin: ${themeSpace(10)} auto 0;
  }
`;

export const SaveDatesImage = styled(Columns)`
  direction: ltr;
`;

export const MainTextFlex = styled(Flex)<{ isImageLeft?: boolean }>`
  background: transparent;
  border-radius: 4px 4px 4px 96px;
  ${themeMediaQuery('sm')} {
    padding-left: ${themeSpace(8)};
  }
`;
